import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'connected-react-router'
import ClientActions from '../../store/clientRedux'
import Loader from '../common/loader'
import LabelledField from '../common/labelledField';
import DateLabelledField from '../common/dateLabelledField'
import '../../stylesheets/productPages.scss';
import Section from '../layout/Section'

class PartyInfoPage extends Component {

    componentWillMount() {
        this.props.getParty(this.props.match.params.id);      
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    toTitleCase = (str) => {
        // handle casing (this is ugly, I know but if I use css to handle casing, the 'et' 
        // in the french format becomes capilalized, which I don't want)
        return str.replace(/(^|[\s-])\S/g, function (t) { return t.toUpperCase() });
    }

    backClick(e) {
        this.props.goBack();
    }

    buildName(firstName, lastName) {
        if(!firstName)
        {
            return "-";
        }
        if(!lastName)
        {
            return firstName;
        }
        return `${firstName} ${lastName}`;
    }

    render() {
        if (this.props.isLoading === true) {
            return <Loader />
        }

        return (
            <div className="content-grid product-info-page">
                <Section sectionId='party-info' className='white'>
                    <div>
                        <h1>Party Information</h1>
                        <LabelledField label="Created by Party Id:" text={this.props.selectedParty.createdByPartyId} />
                        <DateLabelledField label="Created Date:" text={this.props.selectedParty.createdDate} />
                        <LabelledField label="Description:" text={this.props.selectedParty.description} />
                        <LabelledField label="Id:" text={this.props.selectedParty.id} />
                        <LabelledField label="Language:" text={this.props.selectedParty.language} />
                        <LabelledField label="Modified by Party Id:" text={this.props.selectedParty.modifiedByPartyId} />
                        <DateLabelledField label="Modified Date:" text={this.props.selectedParty.modifiedDate} />
                        <LabelledField label="Online Profile Id:" text={this.props.selectedParty.onlineProfileId} />
                        <LabelledField label="Party Type:" text={this.props.selectedParty.partyType} />
                    </div>
                </Section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        layoutType: state.layout.layoutType,
        lang: state.layout.lang,
        appBasePath: state.linkConfig.appConfig.appBasePath,    
        isLoading: state.client.loadingClient,
        selectedParty: state.client.selectedParty
    };
};

const mapDispatchToProps = (dispatch) => ({
    pushNavigation: (path) => dispatch(push(path)),
    goBack: () => dispatch(goBack()),
    getParty: (partyId) => dispatch(ClientActions.getParty(partyId)),    
})


export default connect(mapStateToProps, mapDispatchToProps)(PartyInfoPage)